import { Component, OnInit, Input } from '@angular/core';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Relatie } from 'src/app/shared/model/relatie';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/general/confirm-dialog/confirm-dialog.component';


@Component({
  selector: 'app-relatie-edit',
  templateUrl: './relatie-edit.component.html',
  styleUrls: ['./relatie-edit.component.less']
})
export class RelatieEditComponent implements OnInit {

  id: number;
  branches: any;
  @Input() data: Relatie = null;

  constructor(private relatiesService: RelatiesService,
              private toastr: ToastrService,
              private activatedRoute: ActivatedRoute,
              private routeer: Router,
              private dialog: MatDialog) {

              }

  ngOnInit() {
    const id : any = this.activatedRoute.snapshot.paramMap.get('id') ;
    if (!isNaN(id)) {
      this.id = Number(this.activatedRoute.snapshot.paramMap.get('id'));

      this.relatiesService.getRelatie(this.id).subscribe(o => {
        this.data = o as Relatie;
      }
      );
    } else {
      this.relatiesService.getRelatieByAfkorting(id).subscribe(o => {
        this.data = o as Relatie;
        this.id =this.data.BedrijfNummer
      }
      );
    }
    this.relatiesService.getBranches().subscribe(o => {
      this.branches = o ;
    }
    );

  }

  save() {
    this.relatiesService.saveRelatie(this.id,this.data).subscribe(() => {
        this.toastr.error("", "Opgeslagen");
      }
      );;
  }

  delete() {
    const message = `Weet je zeker dat je dit wilt doen?`;
    let actie = "deactivering"
    if (this.data.IsActief == 0) {
      actie = "activering"
    }
    const dialogData = new ConfirmDialogModel("Bevestig " + actie, message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      const result = dialogResult;
      if (result) {
          this.relatiesService.deleteRelatie(this.id).subscribe(() => {
            if (this.data.IsActief != 0) {
              this.data.IsActief = 0;
              this.toastr.error("", "Gedeactiveerd");
            } else {
              this.data.IsActief = 0;
              this.toastr.error("", "Geactiveerd")
            }
          }
          );
        }
      });

  }

}
